import styled from 'styled-components';
import {
  AccordionSummary as MuiAccordionSummary,
  AccordionSummaryProps,
} from '@mui/material';
import { ReactComponent as ExpandIcon } from '../../assets/arrow-down-expand.svg';
import { radius, space, componentToken } from '../../style/utils';

type Props = AccordionSummaryProps & {
  iconPosition?: 'left' | 'right';
};

const ExpandIconStyled = styled(ExpandIcon)`
  width: 14px;
`;

const AccordionSummaryStyled = styled(MuiAccordionSummary)<{
  $iconPosition: 'left' | 'right';
}>`
  padding: ${space('xxl')};
  height: 98px;
  flex-direction: ${({ $iconPosition }) =>
    $iconPosition === 'left' ? 'row-reverse' : 'row'};
  &.MuiAccordionSummary-root {
    border: 1px solid ${({ theme }) => theme.palette.border.light};
    border-color: ${({ theme }) => theme.palette.border.light};
    border-radius: ${radius('lg')};
    transition: border-radius 0.5s;
  }

  &.MuiAccordionSummary-root.Mui-expanded {
    border-bottom: 1px solid ${componentToken('accordion.summaryDivider')};
    border-radius: ${radius('lg', 'lg', 0, 0)};
    transition: border-radius 0s;
  }

  .MuiAccordionSummary-content {
    margin: 0;
    padding-left: ${({ $iconPosition }) =>
      $iconPosition === 'left' ? space('xxl') : undefined};
  }

  & .MuiAccordionSummary-expandIconWrapper {
    transform: rotate(-90deg);
  }

  & .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
    transform: rotate(-180deg);
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.surface.muted};
  }
`;

const AccordionSummary = ({ iconPosition = 'left', ...props }: Props) => (
  <AccordionSummaryStyled
    expandIcon={<ExpandIconStyled />}
    $iconPosition={iconPosition}
    {...props}
  />
);

export default AccordionSummary;
